import React, { Component } from 'react';
import '../../icons.css';

import { FiLoader } from "react-icons/fi";

class Loading extends Component {
  render() {
    return (
      <div style={{marginTop:"5px", textAlign:"center"}}>
        <FiLoader size={24} className={`icon-spin`} />
      </div>
    );
  }
}

export default Loading;
